/**
 * First-pass check for the editor. The backend runs the complete one (public
 * host only) on save and before every call.
 */
export function isValidWebhookUrl(value: string | undefined): boolean {
  if (!value) return false;
  try {
    return new URL(value.trim()).protocol === "https:";
  } catch {
    return false;
  }
}

export function getWebhookHost(value: string | undefined): string | null {
  if (!isValidWebhookUrl(value)) return null;
  return new URL(value!.trim()).host;
}
